export function getFullName({
  first_name,
  last_name
}: {
  first_name?: string | null;
  last_name?: string | null;
}): string {
  return [first_name, last_name]
    .filter((name) => typeof name === 'string' && name.trim())
    .map((name) => name!.trim())
    .join(' ');
}
